<template>
    <div class="main-area">
        <div v-if="$route.meta.rank == 3">
            <el-breadcrumb separator=":">
                <el-breadcrumb-item>当前位置</el-breadcrumb-item>
                <el-breadcrumb-item>可视化显示</el-breadcrumb-item>
            </el-breadcrumb>

            <el-page-header @back="goBack" content="" class="margin-top-20"></el-page-header>
                <el-row class="margin-top-10">
                  <el-col :span="2" class="margin-top-10">
                    <label class="search-label" style="color: #FFFFFF;">类型：</label>
                  </el-col>
                  <el-col :span="4" class="margin-top-10">
                    <el-select v-model="type"
                               :size="GLOBAL.config.systemSize"
                               placeholder="请选择"
                               style="width: 100%;"
                               clearable
                    >
                      <el-option v-for="item in option"
                                 :label="item.name"
                                 :value="item.code"
                                 :key="item.code"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="2" class="margin-top-10" style="margin-left: 15px;">
                    <el-button type="primary" @click="doSearch" :size="GLOBAL.config.systemSize" icon="el-icon-search">查询
                    </el-button>
                  </el-col>
                 </el-row>
            <el-table style="width: 100%;"
                 height="420"
                :data="tableData"
                element-loading-text="数据处理中...请稍等..."
                v-loading="loading" class="margin-top-20" v-if="params.bcbxflag == '1' || params.bcbxflag == '2'">
                <el-table-column
                    type="index"
                    width="50" label="序号">
                </el-table-column>
<!--                <el-table-column prop="bcrxm" label="报抽人姓名" align="center"/>-->
<!--                <el-table-column prop="bcrsjh" label="报抽人手机号" align="center"/>-->
                <el-table-column prop="mbrxm" label="改厕户姓名" align="center"/>
                <el-table-column prop="mbrsjh" label="改厕户手机号" align="center"/>
                <el-table-column prop="gcbh" label="改厕编号" align="center"/>
                <el-table-column prop="bcsj" label="报抽时间" align="center" :formatter="formatterTime"/>
                <el-table-column prop="siji" label="司机姓名" align="center"/>
                <el-table-column prop="sjsjh" label="司机手机号" align="center"/>
                <el-table-column prop="wcsj" label="完成时间" align="center" :formatter="formatterTime"/>
                <el-table-column prop="zt" label="状态" align="center">
                    <template slot-scope="scope" >
                        <span :style="{'color': (scope.row.zt == '1' ? 'green':'red')}">{{scope.row.zt == '1' ? '已抽' : '未抽'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="pj" label="评价" align="center">
                    <template slot-scope="scope" >
                        <el-rate v-model="scope.row.pj" :allow-half="true"  disabled text-color="#000000" :colors="['#000000', '#000000', '#000000']"></el-rate>
                    </template>
                </el-table-column>
            </el-table>

            <el-table style="width: 100%;"
                height="420"
                :data="tableData"
                element-loading-text="数据处理中...请稍等..."
                v-loading="loading" class="margin-top-20" v-if="params.bcbxflag == '3' || params.bcbxflag == '4'">
                <el-table-column
                    type="index"
                    width="50" label="序号">
                </el-table-column>
<!--                <el-table-column prop="bxrxm" label="报修人姓名" align="center"/>-->
<!--                <el-table-column prop="bxrsjh" label="报修人手机号" align="center"/>-->
                <el-table-column prop="mbrxm" label="改厕户姓名" align="center"/>
                <el-table-column prop="mbrsjh" label="改厕户手机号" align="center"/>
                <el-table-column prop="gcbh" label="改厕编号" align="center"/>
                <el-table-column prop="bxsj" label="报修时间" align="center" :formatter="formatterTime"/>
                <el-table-column prop="dcrUuidName" label="维修人姓名" align="center"/>
                <el-table-column prop="wxrsjh" label="维修人手机号" align="center"/>
                <el-table-column prop="completeTime" label="完成时间" align="center" :formatter="formatterTime"/>
                <el-table-column prop="zt" label="状态" align="center">
                    <template slot-scope="scope" >
                        <span :style="{'color': (scope.row.zt == '1' ? 'green':'red')}">{{scope.row.zt == '1' ? '已修' : '未修'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="pj" label="评价" align="center">
                    <template slot-scope="scope" >
                        <el-rate v-model="scope.row.pj" :allow-half="true"  disabled text-color="#000000" :colors="['#000000', '#000000', '#000000']"></el-rate>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                class="margin-top-10 margin-bottom-20"
                @size-change="tableSizeChange"
                @current-change="currentChange"
                :current-page="pagination.currentPage"
                :page-sizes="pagination.pageSizeList"
                :page-size="pagination.pageSize"
                :layout="pagination.layout"
                :total="pagination.total">
            </el-pagination>
        </div>
        <div v-else>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            params: {
                // 报修和报抽标识 1已抽2未抽3已修4未修
                bcbxflag: '',
                // 类型 1表示所有，2表示月，3表示日
                type: '',
                // 县级或乡镇用户查看全部数据时不需传值，当点击乡镇地图或者村居地图时需要将该村居和该乡镇行政区划代码塞入该值
                code: ''
            },
            option:[{name:'完成',code:'1'},{name:'超时',code:'2'}],
            type:'',
            // 分页参数
            pagination: {
                pageSizeList: [10, 20, 30, 40, 50],
                pageSize: 10,
                layout: 'total, sizes, prev, pager, next, jumper',
                total: 0,
                currentPage: 1
            },
            tableData: [],
            loading: false
        }
    },

    methods: {
        goBack() {
            this.$router.go(-1);
        },
        formatterTime(row, column, data) {
            if (!data) {
                return "";
            }
            var reg = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
            return data.replace(reg, "$1-$2-$3 $4:$5:$6");
        },
         // 分页方法
        tableSizeChange: function (pageSize) {
            this.pagination.pageSize = pageSize
            this.getTableData()
        },
        currentChange: function (current) {
            this.pagination.currentPage = current
            this.getTableData()
        },
        doSearch(){
          this.getTableData('init');
        },
        getTableData(initPageFlag) {
            let _this = this;
            _this.loading = true;
            let method = '';
            let service = '';
            let record = {};
            // 报抽
            if (_this.params.bcbxflag == '1' || _this.params.bcbxflag == '2') {
                // method = 'getBcpage';
                method = _this.GLOBAL.config.handleType.getBsbcPage;
                service =  _this.GLOBAL.config.baseServiceType.TGcBcxxServiceImpl;
            } else {// 报修
                // method = 'getBxpage';
                method = _this.GLOBAL.config.handleType.getBsbxPage;
                service =  _this.GLOBAL.config.baseServiceType.TGcBxxxServiceImpl;
            }
            if (_this.params.code) {
                record.code = _this.params.code;
            }
            if (_this.params.type) {
                record.flag = _this.params.type;
            }
            record.zt = _this.type;

            // 3、 调接口获取数据
            let param = {
                // baseService : "TGcBcxxServiceImpl",
                baseService: service,
                current: initPageFlag ? 1 : _this.pagination.currentPage,
                size: initPageFlag ? 10 : _this.pagination.pageSize,
                records: [record]

            }
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                method,
                param,
                null,
                resultData => {
                    _this.loading = false
                    if (resultData) {
                        // 结果参数赋值
                        _this.tableData = resultData.obj.records;
                        _this.pagination.pageSize = resultData.obj.size
                        _this.pagination.total = resultData.obj.total
                        _this.pagination.currentPage = resultData.obj.current
                        for (const i in _this.tableData) {
                            if (_this.tableData[i].pj) {
                                _this.tableData[i].pj = parseInt(_this.tableData[i].pj);
                            }
                        }
                    } else {
                        _this.$message.warning('获取列表数据失败～')
                    }
                },
                () => {
                    _this.loading = false
                }
            )
        }
    },

    mounted() {
        this.params.bcbxflag = this.$route.params.visualization.bcbxflag;
        this.params.type = this.$route.params.visualization.dayType;
        this.params.code = this.$route.params.visualization.code;
        this.getTableData('init');
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/PrefectureScreen/VisualizationTable.vue